import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PACKAGE_NAME } from '../constants';
import { RootState } from '../types';

const initialState = 0;

const slice = createSlice({
    name: `${PACKAGE_NAME}/discount`,
    initialState,
    reducers: {
        setDiscount: (state, {payload}: PayloadAction<number|string>) =>
            +payload,
    },
});

export default slice.reducer;
export const { name } = slice;
export const { setDiscount } = slice.actions;

// TODO: See note for selectors in './userAddress.ts'

export const selectDiscount = (state: RootState) => state[slice.name];
